 const ContractRoute = {
   path: 'contracts',
   name: 'Contratos',
   component: () => import("@/components/BasicRouter.vue"),
   meta: {
     noHeaderLogo: true
   },
   children: [
     {
       path: '',
       component: () => import("@/views/dashboard/ContractDashboardPage.vue"),
     },
   ]
 }

 export default ContractRoute;
